import { render, staticRenderFns } from "./func.vue?vue&type=template&id=2ec84d90&scoped=true&"
import script from "./func.vue?vue&type=script&lang=js&"
export * from "./func.vue?vue&type=script&lang=js&"
import style0 from "./func.vue?vue&type=style&index=0&id=2ec84d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec84d90",
  null
  
)

export default component.exports